/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { formatToBRL } from "@/utils/formatToMoney";
import { TextAreaModal } from "@/pages/conciliation/evidence-register/components/textarea-modal";
import EvidenceCell from "../components/evidence-cell";

import {
  Controller,
  FieldValues,
  FormProvider,
  UseFormReturn,
} from "react-hook-form";
import SortedCell from "../components/sorted-cell";

interface IUseColumnsProps {
  control: any;
  methods: UseFormReturn<FieldValues, any, undefined>;
  formValidate: () => void;
  hasReviewNotes?: boolean;
}

export const useColumns = ({
  control,
  methods,
  formValidate,
  hasReviewNotes = false,
}: IUseColumnsProps) => {
  const { setValue } = methods;

  return [
    {
      accessorKey: "operator",
      header: "Número do Operador",
      cell: ({ row }: { row: any }) => {
        return (
          <div className="w-full h-full px-[10px] py-[6px] bg-[#E6E6EB] text-[#74788D]">
            {row?.original?.operator}
          </div>
        );
      },
      className: "!p-0 !w-[42px]",
    },
    {
      accessorKey: "name",
      header: "Nome do Operador",
      cell: ({ row }: { row: any }) => {
        return (
          <div className="w-full h-full px-[10px] py-[6px] bg-[#E6E6EB] text-[#74788D]">
            {row?.original?.name}
          </div>
        );
      },
      className: "!p-0 !w-[342px]",
    },
    {
      accessorKey: "amount",
      header: ({ column }: { column: any }) => (
        <SortedCell key={"amount"} column={column} title={"Valor"} />
      ),
      cell: ({ row }: { row: any }) => {
        return (
          <div className="w-full h-full px-[10px] py-[6px] bg-[#E6E6EB] text-[#74788D]">
            {formatToBRL(+row.original.amount)}
          </div>
        );
      },
      className: "!p-0 !w-[150px]",
    },
    {
      accessorKey: "analyst_comments",
      header: "Comentários",
      cell: ({ row }: { row: any }) => {
        return (
          <div className="w-full h-full px-[10px] py-[6px] bg-[#E6E6EB] text-[#74788D]">
            {row.original.analyst_comments}
          </div>
        );
      },
      className: "!p-0 !w-[342px]",
    },
    {
      accessorKey: "store_justification",
      header: ({ }: {}) => (
        <div className="flex w-full align-center justify-start">
          Justificativa da Loja{" "}
          <span className="text-[#d0312d] ml-[3px]">*</span>
        </div>
      ),
      cell: ({ row }: { row: any }) => {
        setValue(
          `divergence_opr.version_${row.original.id}`,
          row.original.version
        );
        setValue(`divergence_opr.id_${row.original.id}`, row.original.id);

        return (
          <FormProvider {...methods}>
            <form className="w-full h-full">
              <Controller
                name={`divergence_opr.store_justification_${row.original.id}`}
                control={control}
                defaultValue={row.original.store_justification}
                render={({ field }) => (
                  <TextAreaModal
                    title="Justificativa da Loja"
                    value={field.value ?? row.original.store_justification ?? ""}
                    onChange={(value) => field.onChange(value)}
                    onBlur={formValidate}
                  />
                )}
              />
            </form>
          </FormProvider>
        );
      },
      className: "!p-0 !w-[342px]",
    },
    ...(hasReviewNotes ? [
      {
        accessorKey: "review_notes",
        header: "Mensagem de Recusa",
        cell: ({ row }: { row: any }) => {
          const reviewNotes = row.original.review_info?.review_notes;
          return (
            <div className="w-full h-full px-[10px] py-[6px] bg-[#E6E6EB] text-[#74788D]">
              {reviewNotes || "-"}
            </div>
          );
        },
        className: "!p-0 !w-[342px]",
      },
    ] : []),
    {
      accessorKey: "evidence",
      header: "Evidência (opcional)",
      cell: ({ row }: { row: any }) => {
        return (
          <EvidenceCell row={row} entity_name="divergence" methods={methods} />
        );
      },
      className: "!p-0 !w-[200px]",
    },
  ];
};